
{
  "actions": {
    "support": "Contact Support"
  }
}
